export default function ReviewDemo() {
  const reviewSections = [
    {
      number: '1',
      title: 'The "First 15" (The Hook)',
      points: [
        { label: 'How fast did I get into the game?', text: 'Was the tutorial too long? Did I get bored?' },
        { label: 'Initial Vibe:', text: 'Is the art style cool or does it feel like a "little kid" game?' },
        { label: 'The Hook:', text: 'What was the exact moment I started having fun?' },
      ],
    },
    {
      number: '2',
      title: 'The Vibe Check (Graphics & Sound)',
      points: [
        { label: 'Art Style:', text: 'Does it look modern or "laggy"?' },
        { label: 'Mac Performance:', text: 'Did it make my Mac get hot? Did it run smooth on the trackpad/mouse?' },
        { label: 'Sound:', text: 'Is the music "bop-worthy" or am I just going to mute it and play Spotify?' },
      ],
    },
    {
      number: '3',
      title: 'The "Grind" (Gameplay & Difficulty)',
      points: [
        { label: 'Difficulty:', text: 'Is it too easy (boring) or so hard I want to rage-quit?' },
        { label: 'Controls:', text: 'Are the Mac keybinds weird, or do they feel natural?' },
        { label: 'The Fun Factor:', text: 'What is the most satisfying thing to do in this game?' },
      ],
    },
    {
      number: '4',
      title: 'The "Cringe" Test',
      points: [
        { label: 'Dialogue/Story:', text: 'Does the dialogue feel like how actual kids talk, or how adults think kids talk?' },
        { label: 'Monetization:', text: 'Do the pop-ups for buying stuff get annoying?' },
      ],
    },
    {
      number: '5',
      title: 'Final Verdict: The "Tell-a-Friend" Score',
      points: [
        { label: 'Score:', text: '8.5 / 10' },
        { label: 'Would I tell my friends about this?', text: 'Yes / No / Maybe' },
        { label: 'The #1 Fix:', text: 'If I could change ONE thing to make my friends play this for hours, it would be: [Insert specific advice here]' },
      ],
    },
  ];

  return (
    <section id="what-you-get" className="py-16 md:py-32 px-4 md:px-8 bg-gradient-to-b from-[#0d0d0f] via-[#1a1a1d] to-[#0d0d0f]">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl md:text-6xl font-bold text-white mb-2 md:mb-4 px-4">What You Actually Get</h2>
          <p className="text-lg md:text-2xl text-[#00f0ff] italic px-4">A real review from a real 12-year-old gamer</p>
        </div>

        <div className="bg-[#1a1a1d] rounded-2xl md:rounded-[32px] p-6 md:p-16 shadow-[0_0_50px_rgba(0,240,255,0.2)]">
          <div className="mb-6 md:mb-8">
            <h3 className="text-xl md:text-3xl font-bold text-white mb-2 md:mb-3">
              <span className="mr-2 md:mr-3">🎮</span>
              Sample Review Report: [Game Name Here]
            </h3>
            <p className="text-[#b8b8b8] text-xs md:text-sm">
              Reviewer: Asher (Age 12) | Platform: Mac | Date: Jan 2026
            </p>
          </div>

          <div className="h-px bg-[#00f0ff] shadow-[0_0_10px_rgba(0,240,255,0.6)] mb-8 md:mb-12"></div>

          <div className="space-y-8 md:space-y-12">
            {reviewSections.map((section, index) => (
              <div key={index}>
                <h4 className="text-lg md:text-2xl font-bold text-white mb-4 md:mb-6">
                  {section.number}. {section.title}
                </h4>
                <div className="space-y-4 md:space-y-6 pl-4 md:pl-8">
                  {section.points.map((point, idx) => (
                    <div key={idx}>
                      <p className="text-[#00f0ff] font-bold mb-1 text-sm md:text-base">{point.label}</p>
                      <p className="text-[#c0c0c0] text-sm md:text-base">{point.text}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 md:mt-12 bg-[#242428] border-l-4 border-[#39ff14] p-4 md:p-8 rounded-lg">
            <div className="flex items-center gap-4 md:gap-8 mb-4">
              <div className="text-5xl md:text-7xl font-black text-[#39ff14]">8.5</div>
              <div className="text-2xl md:text-3xl text-white font-bold">/ 10</div>
            </div>
            <div className="flex items-center gap-2 md:gap-3 mb-4">
              <i className="ri-user-voice-line text-xl md:text-2xl text-[#39ff14]"></i>
              <p className="text-white text-sm md:text-lg font-bold">Would I tell my friends about this? Yes</p>
            </div>
            <div className="mt-4 md:mt-6">
              <p className="text-[#00f0ff] font-bold mb-2 text-sm md:text-base">The #1 Fix:</p>
              <p className="text-[#c0c0c0] italic text-sm md:text-base">
                If I could change ONE thing to make my friends play this for hours, it would be: Add multiplayer co-op mode so we can play together after school.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
